import { isEmpty } from 'lodash';
import { CustomValidateResolveType } from 'tdesign-react';

const validateBots: (
  data: any,
  isBanner: boolean
) => CustomValidateResolveType = (data, isBanner) => {
  if (isEmpty(data)) {
    return { result: false, message: '请选择角色', type: 'error' };
  }
  if (isBanner && data?.bots?.length < 3) {
    return { result: false, message: '最少选择3个角色', type: 'error' };
  }
  return true;
};

export { validateBots };
